module.exports = __webpack_public_path__ + "assets/05b7b72bf6925e0111ecd961ef83300e.mp3";